import useAppParamsAlertNotificationListener from 'src/components/Toasts/AlertNotifications/hooks/useAppParamsAlertNotificationListener';
import useEventEmitterAlertNotificationListener from 'src/components/Toasts/AlertNotifications/hooks/useEventEmitterAlertNotificationListener';
import usePreLaunchMarketAlertNotificationListener from 'src/components/Toasts/AlertNotifications/hooks/usePreLaunchMarketAlertNotificationListener';

export default function useAlertNotificationListener() {
	useAppParamsAlertNotificationListener();
	useEventEmitterAlertNotificationListener();
	usePreLaunchMarketAlertNotificationListener();
}
